module.exports = __webpack_public_path__ + "assets/img/03_jd_100x100.8db5456d.png";